import { useState } from 'react'
import css from './InputPassword.module.scss'
import InputWrap from './InputWrap'

export default function InputPassword({
	value,
	onChange,
	forgetLink,
	showForgot = false,
	label = 'password',
	autoFocus = false,
	onKeyPress,
	helpText
}) {
	const visible = {
		icon: 'fad fa-eye-slash',
		type: 'text',
	}

	const hidden = {
		icon: 'fad fa-eye',
		type: 'password',
	}

	const [isVisible, setIsVisible] = useState(false)
	const [component, setComponent] = useState(hidden)

	function toggleShow() {
		if (isVisible) {
			setComponent(hidden)
			setIsVisible(false)
		} else {
			setComponent(visible)
			setIsVisible(true)
		}
	}

	return (
		<>
			<InputWrap
				label={label}
				icon={component.icon}
				iconClickFunc={toggleShow}
				helpText={helpText}
				component={
					<input
						type={component.type}
						value={value}
						onChange={onChange}
						autoFocus={autoFocus}
						onKeyPress={onKeyPress}
					/>
				}
			/>
			{showForgot && (
				<a
					href={forgetLink}
					className={css['forgot']}>
					Forgot Password?
				</a>
			)}
		</>
	)
}
